/**
 * The implementer of the page information
 */
export var Implementer;
(function (Implementer) {
    Implementer[Implementer["UNKNOWN"] = 0] = "UNKNOWN";
    Implementer[Implementer["ABI"] = 6] = "ABI";
})(Implementer || (Implementer = {}));
